import * as React from "react";
import { styled, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/modules/userSlice";
import { useState } from "react";
import { useAppDispatch } from "../../redux/hooks";
import { logoutSuccess } from "../../redux/modules/userSlice";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { performLogout } from "../api";
import { AUTH_COLORS } from "../../config/authConstants";
import { ADMIN_THEME } from "../../config/adminTheme";

// IMPORTANT: Fix these imports - make sure the paths are correct
// Option 1: If images are in src/Assests/
import Uploadphotoicon from "../../Assests/Images/uploadphotoicon.png";
import spanideaLogo from "../../Assests/Images/auth/spanidea-logo.svg";

// Option 2: If images are in public/ folder, use:
// const Uploadphotoicon = "/Assests/Images/uploadphotoicon.png";
// const spanideaLogo = "/Assests/Images/auth/spanidea-logo.svg";

// Option 3: If images are in src/assets/ (corrected folder name)
// import Uploadphotoicon from "../../assets/Images/uploadphotoicon.png";
// import spanideaLogo from "../../assets/Images/auth/spanidea-logo.svg";

export const mainListItems = (user, open) => {
  return (
    <React.Fragment>
      <NavLink
        to="/AdminDashboard"
        className="admin-nav-link"
        style={{ textDecoration: "None", color: "unset" }}
      >
        <ListItemButton
          sx={{
            borderRadius: 0,
            "&:hover": {
              backgroundColor: "rgba(5, 10, 68, 0.04)",
            },
            "&.active": {
              backgroundColor: "rgba(5, 10, 68, 0.08)",
              borderRight: "3px solid #050A44",
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: "40px", color: "#666" }}>
            <DashboardIcon />
          </ListItemIcon>
          {open && (
            <ListItemText
              primary="Dashboard"
              primaryTypographyProps={{
                fontSize: "14px",
                fontWeight: 500,
                color: "#333",
              }}
            />
          )}
        </ListItemButton>
      </NavLink>
      {user.isSuperAdmin ? (
        <NavLink
          to="/AdminUsers"
          className="admin-nav-link"
          style={{ textDecoration: "None", color: "unset" }}
        >
          <ListItemButton
            sx={{
              borderRadius: 0,
              "&:hover": {
                backgroundColor: "rgba(5, 10, 68, 0.04)",
              },
              "&.active": {
                backgroundColor: "rgba(5, 10, 68, 0.08)",
                borderRight: "3px solid #050A44",
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: "40px", color: "#666" }}>
              <PeopleOutlineIcon />
            </ListItemIcon>
            {open && (
              <ListItemText
                primary="HR"
                primaryTypographyProps={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#333",
                }}
              />
            )}
          </ListItemButton>
        </NavLink>
      ) : (
        ""
      )}
      {user.isAdmin ? (
        <NavLink
          to="/AdminEmployees"
          className="admin-nav-link"
          style={{ textDecoration: "None", color: "unset" }}
        >
          <ListItemButton
            sx={{
              borderRadius: 0,
              "&:hover": {
                backgroundColor: "rgba(5, 10, 68, 0.04)",
              },
              "&.active": {
                backgroundColor: "rgba(5, 10, 68, 0.08)",
                borderRight: "3px solid #050A44",
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: "40px", color: "#666" }}>
              <PersonOutlineOutlinedIcon />
            </ListItemIcon>
            {open && (
              <ListItemText
                primary="Employees"
                primaryTypographyProps={{
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#333",
                }}
              />
            )}
          </ListItemButton>
        </NavLink>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  backgroundColor: "#FFFFFF",
  color: AUTH_COLORS.text,
  boxShadow: "none",
  borderBottom: "1px solid " + AUTH_COLORS.borderSecondary,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    backgroundColor: AUTH_COLORS.surface,
    borderRight: "1px solid " + AUTH_COLORS.borderSecondary,
    fontFamily: '"Poppins", "TTHoves", "Segoe UI", sans-serif',
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

function AdminSidebar() {
  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const pathname = location.pathname;
  const navigate = useNavigate();
  const toggleDrawer = () => {
    setOpen(!open);
  };
  const { user } = useSelector(selectUser);

  const isAuthRoute =
    pathname === "/login" ||
    pathname === "/AdminLogin" ||
    pathname === "/otp-verify";

  const isJoineeShell = user && user._id && !user.isAdmin && !user.isSuperAdmin;

  const handleLogout = () => {
    performLogout().then(
      function () {
        dispatch(logoutSuccess());
        navigate("/login");
      },
      function () {
        dispatch(logoutSuccess());
        navigate("/login");
      }
    );
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    handleMenuClose();
    navigate(
      user.isAdmin || user.isSuperAdmin ? `/AdminProfile` : "/profile"
    );
  };

  if (isAuthRoute || isJoineeShell) {
    return null;
  }

  return (
    <ThemeProvider theme={ADMIN_THEME}>
      <Box sx={{ display: "flex", height: "100vh" }}>
        <CssBaseline />
        <AppBar position="fixed" open={open} color="inherit" elevation={0}>
          <Toolbar
            sx={{
              pr: "24px",
              bgcolor: "#FFFFFF",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {pathname === "/AdminUsers" ||
              pathname === "/AdminEmployees" ||
              pathname === "/AdminDashboard" ||
              pathname === "/AdminProfile" ? (
                <IconButton
                  edge="start"
                  aria-label="open drawer"
                  onClick={toggleDrawer}
                  sx={{
                    marginRight: "36px",
                    color: AUTH_COLORS.primary,
                    ...(open && { display: "none" }),
                  }}
                >
                  <MenuIcon />
                </IconButton>
              ) : (
                ""
              )}
              <Typography
                component="h1"
                variant="h6"
                color="inherit"
                noWrap
                sx={{ display: "flex", alignItems: "center" }}
              >
                <img
                  src={spanideaLogo}
                  alt="Spanidea Systems"
                  style={{ width: "160px", height: "20px", display: "block" }}
                />
              </Typography>
            </Box>
            <Box>
              {pathname !== "/login" &&
              pathname !== "/AdminLogin" &&
              pathname !== "/otp-verify" ? (
                <>
                  <IconButton
                    onClick={handleMenuOpen}
                    size="small"
                    aria-label="Open profile menu"
                    sx={{
                      p: "3px",
                      border: "1px solid " + AUTH_COLORS.borderSecondary,
                      "&:hover": { borderColor: AUTH_COLORS.primary },
                    }}
                  >
                    <Avatar
                      src={user && user.profilePhoto ? user.profilePhoto : Uploadphotoicon}
                      alt={user && user.name ? user.name : "Profile"}
                      sx={{ width: 32, height: 32 }}
                    />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    PaperProps={{
                      sx: {
                        mt: 1.25,
                        minWidth: 240,
                        borderRadius: "10px",
                        border: "1px solid " + AUTH_COLORS.borderSecondary,
                        boxShadow: "0 12px 32px rgba(5, 10, 68, 0.12)",
                        "& .MuiMenuItem-root": {
                          gap: 1.25,
                          px: 2,
                          py: 1.1,
                          fontSize: 14,
                          color: AUTH_COLORS.text,
                          "&:hover": { backgroundColor: AUTH_COLORS.bgSoft },
                        },
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        px: 2,
                        py: 1.5,
                      }}
                    >
                      <Avatar
                        src={user && user.profilePhoto ? user.profilePhoto : Uploadphotoicon}
                        alt=""
                        sx={{ width: 40, height: 40 }}
                      />
                      <Box sx={{ minWidth: 0 }}>
                        <Typography
                          noWrap
                          sx={{ fontSize: 14, fontWeight: 600, color: AUTH_COLORS.text }}
                        >
                          {(user && user.name) || "HR"}
                        </Typography>
                        <Typography
                          noWrap
                          sx={{ fontSize: 12, color: AUTH_COLORS.textSecondary }}
                        >
                          {(user && user.email) || ""}
                        </Typography>
                      </Box>
                    </Box>
                    <Divider sx={{ my: 0.5 }} />
                    <MenuItem onClick={handleProfileClick}>
                      <PersonOutlineOutlinedIcon
                        sx={{ fontSize: 20, color: AUTH_COLORS.textSecondary }}
                      />
                      My Profile
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        handleMenuClose();
                        handleLogout();
                      }}
                      sx={{ "&&": { color: AUTH_COLORS.error } }}
                    >
                      <LogoutOutlinedIcon sx={{ fontSize: 20 }} />
                      Logout
                    </MenuItem>
                  </Menu>
                </>
              ) : (
                ""
              )}
            </Box>
          </Toolbar>
        </AppBar>
        {pathname === "/AdminUsers" ||
        pathname === "/AdminEmployees" ||
        pathname === "/AdminDashboard" ||
        pathname === "/AdminProfile" ? (
          <Drawer variant="permanent" open={open}>
            <Toolbar
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: [1],
                backgroundColor: "#050A44",
                color: AUTH_COLORS.buttonLabel,
              }}
            >
              {open && (
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    fontSize: 18,
                    margin: 0,
                    padding: "0 8px",
                    color: "#FFFFFF",
                  }}
                >
                  HR Portal
                </Typography>
              )}
              <IconButton onClick={toggleDrawer}>
                <ChevronLeftIcon sx={{ color: AUTH_COLORS.buttonLabel }} />
              </IconButton>
            </Toolbar>
            <List component="nav" sx={{ pt: 0 }}>
              {mainListItems(user, open)}
            </List>
          </Drawer>
        ) : (
          ""
        )}
      </Box>
    </ThemeProvider>
  );
}

export default AdminSidebar;